<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(errorMessage == '' || errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-xs-3">
              <h3>MIS Report</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                "
              />
            </div>
          </div>

          <div
            v-if="!(userBank.Name == null || userBank.Name == '')"
            class="row"
          >
            <div class="col-md-6">
              <h3>{{ userBank.Name }}</h3>
            </div>
            <div class="col-md-6 text-right">
              <img
                style="padding: 10px"
                src="../../assets/imgs/BIsBR.png"
                v-hide="!(userBank.Name == null || userBank.Name == '')"
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />
            <date-pick
              style="margin-left: 4px"
              v-model="startdate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'From Date',
              }"
            ></date-pick>
            <date-pick
              style="margin-left: 4px"
              v-model="enddate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'To Date',
              }"
            ></date-pick>

            <select
              class="form-control"
              v-model="Status"
              style="margin-left: 5px; width: 16%"
            >
              <option value>All</option>
              <option value="1">Completed Requests</option>
              <option value="2">Pending Request</option>
              <option value="3">Cancelled</option>
            </select>
            <select
              class="form-control"
              v-model="deptId"
              style="margin-left: 5px; width: 16%"
            >
              <option value>All</option>
              <option
                v-for="(option, index) in department"
                :key="index"
                :value="option.Id"
              >
                {{ option.Name }}
              </option>
            </select>
          </div>

          <div class="form-group form-inline custom-width">
            <a
              href="javascript:void(0)"
              class="btn btn-primary"
              style="margin-left: 10px"
              @click="Filter"
              >Filter</a
            >
            <input
              type="button"
              class="btn btn-primary"
              value="Download Excel"
              @click="DownloadMISExcel"
              style="margin-left: 10px"
            />
            <input
              type="button"
              class="btn btn-primary"
              value="PDF Download"
              @click="DownloadMISPdf"
              style="margin-left: 10px; margin-right: 10px"
            />
            <loading v-if="docsloading"></loading>
          </div>
          <div
            v-if="!(docserror == '' || docserror == null)"
            class="alert alert-danger text-center custom-width alert-custom"
          >
            <strong>{{ docserror }}</strong>
          </div>
          <div v-bind:id="'printable'" style="overflow-x: scroll">
            <strong v-currentdate>Current Date Time</strong>
            <table class="table table-bordered ng-grid" style="width: 100%">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('RefNo')"
                      >Ref No</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'RefNo'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('BankReference')"
                      >Your Reference</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'BankReference'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ClientName')"
                      >Client Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ClientName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('TransferOwner')"
                      >New Owner</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'TransferOwner'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('DepartmentName')"
                      >Department Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'DepartmentName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ApplicationDate')"
                      >Transaction Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ApplicationDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ValueDate')"
                      >Value Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ValueDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('MaturityDate')"
                      >Maturity Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'MaturityDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Commission')"
                      >Commission</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Commission'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Amount')"
                      >Amount</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Amount'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('CommodityName')"
                      >Commodity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'CommodityName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Quantity')"
                      >Quantity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Quantity'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('RequesterName')"
                      >Requested By</a
                    >
                    <span
                      class="sortorder"
                      @click="ChangeOrder('RequesterName')"
                      v-show="currentSort == 'RequesterName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>Physical Delivery</th>
                  <th class="Print">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td>
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td>{{ option.RefNo }}</td>
                  <td>{{ option.BankReference }}</td>
                  <td>{{ option.ClientName }}</td>
                  <td>{{ option.TransferOwner }}</td>
                  <td>{{ option.DepartmentName }}</td>
                  <td>{{ DateFromat(option.ApplicationDate) }}</td>
                  <td>{{ DateFromat(option.ValueDate) }}</td>
                  <td>{{ DateFromat(option.MaturityDate) }}</td>
                  <td>
                    <span class="green" style="float: left">
                      USD
                      <br />
                      {{ option.USDCommission.toFixed(2) }}
                    </span>
                  </td>
                  <td>
                    <span class="green" style="float: left">
                      {{ option.CurrencyShortname }}
                      <br />
                      {{ option.StringAmount }}
                    </span>
                  </td>
                  <td>{{ option.CommodityName }}</td>
                  <td>{{ option.StringQuantity }}</td>
                  <td>{{ option.RequesterName }}</td>
                  <td>
                    <span v-if="option.PhysicalDelivery">Yes</span>
                    <span v-else>No</span>
                  </td>
                  <td class="img Print">
                    <span v-if="option.Cancelled == 'Y'">Cancelled</span>
                    <span v-else-if="option.Sell">Complete</span>
                    <span v-else>Pending</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import DatePick from "vue-date-pick";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,

      Status: null,
      startdate: null,
      enddate: null,
      deptId: null,
      RequestId: null,
      Search: null,
      currentSort: "RefNo",
      curentSortOrder: "desc",
      userBank: { Name: null },
    };
  },
  components: {
    DatePick,
  },
  methods: {
    DownloadMISExcel() {
      this.CheckDates();
      //var URL = "/DownloadMIS";
      var URL =
        "/DownloadMIS?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&startdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&enddate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status) +
        "&deptid=" +
        (this.deptId == null ? "" : this.deptId) +
        "&order=" +
        (this.currentSort == null ? "" : this.currentSort) +
        "&OrderBy=" +
        (this.curentSortOrder == null ? "" : this.curentSortOrder);
      var vm = this;

      this.$store
        .dispatch(ACTIONS.DOWNLOAD_DOCUMENT, URL)
        .then((res) => {
          if (res.status == 200) {
            vm.SaveFile(res.data, ".xls");
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    DownloadMISPdf() {
      this.CheckDates();
      var URL =
        "/MISPDF?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&startdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&enddate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status) +
        "&deptid=" +
        (this.deptId == null ? "" : this.deptId) +
        "&order=" +
        (this.currentSort == null ? "" : this.currentSort) +
        "&OrderBy=" +
        (this.curentSortOrder == null ? "" : this.curentSortOrder);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.DOWNLOAD_DOCUMENT, URL)
        .then((res) => {
          if (res.status == 200) {
            vm.SaveFile(res.data, ".pdf");
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    CheckDates() {
      if (this.startdate == "") {
        this.startdate = null;
      }
      if (this.enddate == "") {
        this.enddate = null;
      }
    },
    SaveFile(data, ext) {
      var _name = null;
      var d = new Date();
      //if (fileName) {
      _name =
        "MIS_Report_" +
        (d.getFullYear() % 100) +
        "_" +
        d.getMonth() +
        "_" +
        d.getDate() +
        ext;

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", _name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ListAcceptedId = [];
        this.ChnageUrl();
        this.GetData();
      }
    },

    Filter() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    ChnageUrl() {
      this.CheckDates();
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort +
        "&fromdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&todate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status) +
        "&deptid=" +
        (this.deptId == null ? "" : this.deptId) +
        "&order=" +
        (this.currentSort == null ? "" : this.currentSort) +
        "&OrderBy=" +
        (this.curentSortOrder == null ? "" : this.curentSortOrder);
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ListAcceptedId = [];
      this.ChnageUrl();
      this.GetData();
    },

    GetData() {
      this.CheckDates();
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&startdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&enddate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status) +
        "&deptid=" +
        (this.deptId == null ? "" : this.deptId);

      var vm = this;
      this.$store
        .dispatch(ACTIONS.MIS_GET_ALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
      if (
        this.$route.query.hasOwnProperty("fromdate") &&
        this.$route.query["fromdate"] != null &&
        this.$route.query["fromdate"] != ""
      ) {
        this.startdate = this.setFormDate(this.$route.query["fromdate"]);
      }
      if (
        this.$route.query.hasOwnProperty("todate") &&
        this.$route.query["todate"] != "" &&
        this.$route.query["todate"] != null
      ) {
        this.enddate = this.setFormDate(this.$route.query["todate"]);
      }
      if (this.$route.query.hasOwnProperty("status")) {
        this.Status = this.$route.query["status"];
      }
      if (this.$route.query.hasOwnProperty("deptid")) {
        this.deptId = this.$route.query["deptid"];
      }
      if (this.$route.query.hasOwnProperty("order")) {
        this.currentSort = this.$route.query["order"];
      }
      if (this.$route.query.hasOwnProperty("OrderBy")) {
        this.curentSortOrder = this.$route.query["OrderBy"];
      }
    }

    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      Request: "GETMISREQUEST",
      TotalRecords: "GETMISTotalPages",
      errorMessage: "GETMISERROR",
      loading: "GETMISLOADING",
      //  UserDept: "deptId",
      department: "GETMISDEPARTMENTS",
      docsloading: "DOCSLOADING",
      docserror: "DOCSERRORMESSAGE",
      BankLogo: "GETBANKLOGO",
    }),
    OrderBy() {
      var data = [...this.Request];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      // this.selectList = [];
      // for (var i = 0; i < SortedArray.length; i++) {
      //   this.selectList.push({
      //     value: SortedArray[i].Accepted,
      //     id: SortedArray[i].RequestId,
      //     accpted: SortedArray[i].Accepted
      //   });
      // }
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }

      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      return this.Pagination(SortedArray, sp, cp);
      // return SortedArray;
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>